import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../logo.png';
import {
  Box,
  Typography,
  Paper,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  Alert,
  Divider,
} from '@mui/material';
import { tenses } from '../data/tenses';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const [selectedTenses, setSelectedTenses] = useState<string[]>([]);
  const [error, setError] = useState<string | null>(null);

  const handleTenseChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const tenseId = event.target.name;
    
    if (event.target.checked) {
      setSelectedTenses([...selectedTenses, tenseId]);
    } else {
      setSelectedTenses(selectedTenses.filter(id => id !== tenseId));
    }
    
    // Clear error when user makes a selection
    if (error) setError(null);
  };

  const handleStartQuiz = () => {
    if (selectedTenses.length === 0) {
      setError('Please select at least one tense to practice');
      return;
    }
    
    // Store selected tenses in session storage
    sessionStorage.setItem('selectedTenses', JSON.stringify(selectedTenses));
    
    // Navigate to quiz page
    navigate('/quiz');
  };

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Box 
        component="h1" 
        sx={{ 
          my: 4,
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <img src={logo} alt="Deux Baguettes" style={{ maxHeight: '120px' }} />
      </Box>
      
      <Typography variant="h5" component="h2" gutterBottom>
        French Verb Conjugation Practice
      </Typography>
      
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          mt: 4, 
          maxWidth: 600, 
          mx: 'auto',
          borderRadius: 2
        }}
      >
        <Typography variant="h6" component="h3" gutterBottom>
          Select the tenses you want to practice:
        </Typography>
        
        <Divider sx={{ my: 2 }} />
        
        <FormGroup sx={{ mt: 2 }}>
          {tenses.map((tense) => (
            <FormControlLabel
              key={tense.id}
              control={
                <Checkbox
                  name={tense.id}
                  checked={selectedTenses.includes(tense.id)}
                  onChange={handleTenseChange}
                  color="primary"
                />
              }
              label={tense.display}
              sx={{ textAlign: 'left', mb: 1 }}
            />
          ))}
        </FormGroup>
        
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
        
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleStartQuiz}
          sx={{ mt: 4, px: 4, py: 1.5 }}
        >
          Start Practice
        </Button>
      </Paper>
    </Box>
  );
};

export default HomePage;
